export const METERS_IN_MILE = 1609.344;
export const METERS_IN_KILOMETER = 1000;

export const SECONDS_IN_MINUTE = 60;
export const MINUTES_IN_HOUR = 60;
export const HOURS_IN_DAY = 24;

export const MARATHON_DISTANCE_METERS = 42195;
export const HALF_MARATHON_DISTANCE_METERS = 21097;
